import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { UNIT_SCOPE_OPTIONS, type UnitScope } from "./usage-billing-unit-scope";

type UsageBillingUnitScopeControlProps = {
  scope: UnitScope;
  onChange: (scope: UnitScope) => void;
};

export function UsageBillingUnitScopeControl({
  scope,
  onChange,
}: UsageBillingUnitScopeControlProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Business unit scope"
      className="flex items-center gap-0.5 rounded-md border bg-gray-50 p-0.5"
    >
      {UNIT_SCOPE_OPTIONS.map((option) => (
        <Button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={scope === option.value}
          variant={scope === option.value ? "default" : "ghost"}
          size="sm"
          onClick={() => onChange(option.value)}
          className={cn(
            "h-7 px-2.5 text-xs font-normal",
            scope !== option.value && "text-gray-600 hover:text-gray-900",
          )}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
